/**
 * Parses a file name and extracts its name (without extension) and extension.
 *
 * @param fileName - The file name to parse
 * @returns An object containing the name without extension and the extension (if found)
 *
 * @example
 * parseFileName('document.pdf') // { name: 'document', extension: 'pdf' }
 * parseFileName('archive.tar.gz') // { name: 'archive.tar', extension: 'gz' }
 * parseFileName('README') // { name: 'README', extension: '' }
 *
 * @__NO_SIDE_EFFECTS__
 */
export function parseFileName(fileName: string | null | undefined) {
    if (!fileName) {
        return {
            name: null,
            extension: null,
        };
    }

    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1) {
        return {
            name: fileName,
            extension: null,
        };
    }

    const name = fileName.slice(0, lastDotIndex);
    const extension = fileName.slice(lastDotIndex + 1);

    return {
        name,
        extension,
    };
}
